export const convertFieldsToDate = <T>(obj: Record<string, any>, fields: string[]): T => {
    const newObj = { ...obj };
    fields.forEach((field) => {
        if (newObj[field]) {
            newObj[field] = new Date(newObj[field]);
        }
    });
    return newObj as T;
};  